import { render, staticRenderFns } from "./VerifyProductsCatalog.vue?vue&type=template&id=57880cb0&scoped=true&"
import script from "./VerifyProductsCatalog.vue?vue&type=script&lang=js&"
export * from "./VerifyProductsCatalog.vue?vue&type=script&lang=js&"
import style0 from "./VerifyProductsCatalog.vue?vue&type=style&index=0&id=57880cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57880cb0",
  null
  
)

export default component.exports